import { render, staticRenderFns } from "./WorkbenchsingleReport.vue?vue&type=template&id=005488f6&scoped=true&"
import script from "./WorkbenchsingleReport.vue?vue&type=script&lang=js&"
export * from "./WorkbenchsingleReport.vue?vue&type=script&lang=js&"
import style0 from "./WorkbenchsingleReport.vue?vue&type=style&index=0&id=005488f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005488f6",
  null
  
)

export default component.exports